/* import __COLOCATED_TEMPLATE__ from './table-teammate-cell.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { ES_MISSING_INTEGER_BUCKET_KEY, UNKNOWN } from 'embercom/lib/reporting/flexible/constants';

export default class TableComponent extends Component {
  col = this.args.col;

  constructor() {
    super(...arguments);

    this.groupName = this.args.row.groupName;
  }

  get isTeammate() {
    return !isNaN(this.groupName);
  }

  get teammate() {
    return this.args.data[this.groupName];
  }

  get name() {
    if (String(this.groupName) === ES_MISSING_INTEGER_BUCKET_KEY) {
      return UNKNOWN;
    }
    if (this.isTeammate && this.teammate) {
      return this.teammate.name;
    } else if (this.col.aliases) {
      return this.col.aliases[this.groupName] || 'unknown';
    } else {
      return this.groupName;
    }
  }
}
